<template>
    <div>
        <div class="row">
            <div class="col-2"></div>
            <div class="col-10 d-flex justify-content-center align-items-center">
                <p class="mb-0 me-2">PACKS ({{ packs.length }}) </p>
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    Create
                </button>
            </div>
        </div>
        <div class="row" v-if="viewData">
            <div class="col-2"></div>
            <div class="col-2" v-for="(product, index) in packs" :key="index">
                <div class="d-flex justify-content-between align-items-center">
                    <p class="mb-0">{{ product.id }} - Status: Published</p> <button
                        class="btn btn-sm btn-danger">X</button>
                </div>
                <div class="box-img">
                    <img :src="product.other_product.first_image.path" alt=""
                        v-if="product.other_product && product.other_product.first_image">
                </div>
                <div v-if="product">
                    <p>{{ product.other_product.title }}</p>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <p>Moneys:</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6" v-if="product.other_product && product.other_product.moneys">
                        <span v-for="(money, index) in product.other_product.moneys" :key="index">
                            {{ index + ' | S/. ' + money.price }} <br>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <button class="btn btn-primary">Edit</button>
                </div>
            </div>
        </div>
        
        

        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                ...
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Relations',
    props: ['data','viewData'],
    data() {
        return {
            packs: this.data
        }
    },
    methods: {

    },

}
</script>
<style></style>